'use client';

import React, { useState, useEffect, useRef } from 'react';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import Features from './Features';
import PersonaSection from './PersonaSection';
import Comparison from './Comparison';
import SocialSection from './SocialSection';
import FinalCTA from './FinalCTA';

const HomePage: React.FC = () => {
  const graphPaperSentinelRef = useRef<HTMLDivElement>(null);
  const [graphPaperVisible, setGraphPaperVisible] = useState(false);
  const [gridBgUrl, setGridBgUrl] = useState('');

  useEffect(() => {
    const el = graphPaperSentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setGraphPaperVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!graphPaperVisible || gridBgUrl) return;
    import('@/lib/roughGrid').then(({ generateRoughGridTile }) => {
      const isMobile = window.innerWidth < 768;
      const url = generateRoughGridTile({
        size: isMobile ? 120 : 140,
        minorDivisions: 5,
        minorColor: 'rgba(66, 143, 233, 0.06)',
        majorColor: 'rgba(66, 143, 233, 0.10)',
        roughness: 0.3,
        strokeWidth: 1,
      });
      setGridBgUrl(url);
    });
  }, [graphPaperVisible, gridBgUrl]);

  return (
    <>
      <div
        className={`bg-graph-paper ${graphPaperVisible ? 'is-visible' : ''}`}
        style={gridBgUrl ? { backgroundImage: `url(${gridBgUrl})` } : undefined}
      />
      <div className="relative z-[2] flex flex-col">
        <Hero />
        <div ref={graphPaperSentinelRef} />
        <HowItWorks />
        <Features />
        <PersonaSection />
        <Comparison />
        <SocialSection />
        <FinalCTA />
      </div>
    </>
  );
};

export default HomePage;
